// 기기 카테고리별 아이콘 상수들
import React from 'react';
import TabletMacIcon from '@mui/icons-material/TabletMac';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import { DeviceCategory } from '../../../../constants/unifiedDeviceData';

export const categoryIcons: Record<DeviceCategory, React.ReactElement> = {
  '태블릿': <TabletMacIcon sx={{ fontSize: 32 }} />,
  '스마트폰': <SmartphoneIcon sx={{ fontSize: 32 }} />,
  '웨어러블': <HeadphonesIcon sx={{ fontSize: 32 }} />,
};
